<template>
    <div class="panel panel-info">
        <div class="panel-heading">
            {{ title }}
        </div>
        <div class="panel-body bg-gray">
            <ProgressBar :goal="goal" :left="left" />
            <div style="color:black; font-weight: bold">
                {{ goal - left }} / {{ goal }}
            </div>
        </div>
    </div>
</template>

<script>

import ProgressBar from "../../../common/ProgressBar";
export default {
    name: "TrafficInfoPanel",
    components: {ProgressBar},
    props: {
        title: {
            type: String,
            required: true
        },
        goal: {
            type: Number,
            required: true,
            default: 0
        },
        left: {
            type: Number,
            required: true,
            default: 0
        }

    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/widgets/InsightWidget/Panel/TrafficInfoPanel.vue